import en from './en.json';
import zh_CN from './zh-CN.json';
import zh_TW from './zh-TW.json';

const userLang = navigator.language || navigator.userLanguage; // 获取浏览器语言
let DEFAULT_LANGUAGE = 'en';

if (userLang.startsWith('zh-CN')) {
	DEFAULT_LANGUAGE = 'zh-CN';
} else if (userLang.startsWith('zh-TW')) {
	DEFAULT_LANGUAGE = 'zh-TW';
}

let locale = uni.getStorageSync('locale') || DEFAULT_LANGUAGE;
let messages = { en, zh_CN, zh_TW };


import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale,
	messages
});

// ✅ Vue 2 - 添加全局翻译方法
Vue.prototype.$translate = (key, params) => i18n.t(key, params);

// ✅ 导出全局翻译方法
export const translate = (key, params) => i18n.t(key, params);

















/**
 * **🔹 切换语言方法**
 */
export const setLanguage = (lang) => {

	i18n.locale = lang;





	uni.setStorageSync('locale', lang);
};


export default i18n;